import "bootstrap";

$(() => {
  const win = $(window);

  // scrollToTop.
  const jsScrollUp = $(".js-scroll-up");
  const jsShrinkHeader = $(".js-shrink-header");
  const jsRemoveElement = $(".js-remove-element");
  const jsShrinkElement = $(".js-shrink-element");

  win.on("load scroll", function scrollToTop() {
    const scrollValue = $(this).scrollTop();
    const ignorePages = $("#page").hasClass(["contact/mail-form"]);

    if (ignorePages === false) {
      if (scrollValue > 300) {
        jsScrollUp.fadeIn();
        // for Desktop header.
        jsShrinkHeader.addClass("js-shrink-header--active");
        jsRemoveElement.addClass("js-display-none");
        jsShrinkElement.addClass("js-display-block");
      } else {
        jsScrollUp.fadeOut();
        // for Desktop header.
        jsShrinkHeader.removeClass("js-shrink-header--active");
        jsRemoveElement.removeClass("js-display-none");
        jsShrinkElement.removeClass("js-display-block");
      }
    }
  });

  jsScrollUp.on("click", () => {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      500
    );
  });

  // More Content Button
  const jsContent = $(".js-content");
  const jsContentHide = $(".js-content-hide");
  const jsMore = $(".js-more");
  const jsContentHideAll = $(".js-content-hide-all");
  const jsMoreAll = $(".js-more-all");
  const jsMoreFlex = $(".js-more-flex");

  jsMore.on("click", function removeContentBackground() {
    $(this).css("cssText", "display: none !important");
    $(this)
      .next(jsContentHide)
      .slideDown("fast");
    jsContent.removeClass("js-content-bg");
  });

  jsMoreAll.on("click", function removeContentBackground() {
    $(this).css("cssText", "display: none !important");
    $(this)
      .next(jsContentHideAll)
      .slideDown("fast");
    jsContent.removeClass("js-content-bg--white");
    jsContent.removeClass("js-content-bg--lightgray");
  });

  jsMoreFlex.on("click", function collapseContent() {
    $(this).css("cssText", "display: none !important");
    $(this)
      .next($(".collapse"))
      .css("display", "flex");
  });

  // Smooth Scrolling
  $('a[href*="#pl-"]:not([href="#pl-"])').on("click", function() {
    if (
      location.pathname.replace(/^\//, "") ===
        this.pathname.replace(/^\//, "") &&
      location.hostname === this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top + -106
          },
          500
        );
        return false;
      }
    }
  });

  // Search map list animation.
  const jsSearchMapBtn = $(".js-search-map__btn");
  const jsSearchMapBtnList = $(".js-search-map__btn--list");
  const jsSearchMapList = $(".js-search-map__list__container");

  jsSearchMapBtn.on("click", function() {
    jsSearchMapList.fadeOut("fast", function() {
      jsSearchMapBtnList.css("display", "block");
      jsSearchMapBtn.css("display", "none");
    });
  });

  jsSearchMapBtnList.on("click", function() {
    jsSearchMapList.fadeIn("fast", function() {
      jsSearchMapBtnList.css("display", "none");
      jsSearchMapBtn.css("display", "block");
    });
  });

  // Search form slider
  // スライダーを適用
  $("#slider-floor, #slider-floor-map").slider({
    min: 0,
    max: 9999,
    step: 1,
    range: true,
    values: [0, 9999],
    // スライダーの変化時にテキストボックスの値表示を更新
    change: function(e, ui) {
      $("#min-floor, #min-floor-map").val(ui.values[0]);
      $("#max-floor, #max-floor-map").val(ui.values[1]);
    },
    // スライダーの初期化時に、その値をテキストボックスにも反映
    create: function() {
      var values = $(this).slider("option", "values");
      $("#min-floor, #min-floor-map").val(values[0]);
      $("#max-floor, #max-floor-map").val(values[1]);
    }
  });

  $("#slider-year, #slider-year-map").slider({
    min: 0,
    max: 99,
    step: 1,
    range: true,
    values: [0, 99],
    change: function(e, ui) {
      $("#min-year, #min-year-map").val(ui.values[0]);
      $("#max-year, #max-year-map").val(ui.values[1]);
    },
    create: function() {
      var values = $(this).slider("option", "values");
      $("#min-year, #min-year-map").val(values[0]);
      $("#max-year, #max-year-map").val(values[1]);
    }
  });

  // Layout the DIV box to fit the window for Smartphone view.
  const heightSize = win.height();
  $(".search-map--map").height(heightSize); // Search Map
  $(".navbar-nav").css({ maxHeight: heightSize - 43 + "px" }); // Global Navigation

  // Keep the dropdown menu opening on Global Navigation.
  $("a.dropdown-item").on("click", function(e) {
    e.stopPropagation();
  });

  // Prevent page scrolling when a global navigation menu is Open.
  $(".navbar-toggler").on("click", function() {
    if ($(this).hasClass("collapsed")) {
      const position = win.scrollTop();

      $("body").css({
        position: "fixed",
        top: -1 * position,
        width: "100vw",
        marginTop: 0
      });
    } else {
      const position = $("body").css("top");

      $("body").css({
        position: "",
        top: "",
        width: "inherit",
        marginTop: "46px"
      });

      win.scrollTop(parseInt(position, 10) * -1);
    }
  });
});
